module.exports = __webpack_public_path__ + "img/7.a5ab6684.png";